// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Subcategories_subcategories__iZqYK {
  max-width: 26rem;
  --padding-inline-start: 2rem;
  border: 0.1rem solid var(--black-ten-opacity);
  border-radius: 0.8rem;
  padding-block: 1.7rem 1.2rem;
  position: sticky;
  top: 2rem;
}

.Subcategories_subcategories__header__xnljO {
  color: var(--primary-color);
  font-size: var(--text-xl);
  font-weight: 700;
  padding-inline-start: var(--padding-inline-start);
  margin-bottom: 1rem;
}

.Subcategories_subcategories__loading__oJP34 {
  margin-inline: auto;
  width: 8rem;
  height: 6rem;
}

.Subcategories_subcategories__empty__HF7cf {
  margin-block: 5rem;
}

.Subcategories_subcategories__empty__HF7cf .icon-wrapper {
  padding: 2rem;
}

.Subcategories_subcategories__empty__HF7cf .icon {
  width: 3rem;
  height: 3rem;
  object-fit: contain;
}

.Subcategories_subcategories__empty__HF7cf .message {
  font-size: var(--text-sm);
}

.Subcategories_subcategories__list-item__f5Jtg {
  padding-inline-start: var(--padding-inline-start);
  padding-block: 1.5rem;
  color: #000;
  font-size: var(--text-base);
  font-weight: 500;
}

.Subcategories_subcategories__list-item__f5Jtg:hover {
  border-radius: 0.7rem;
  box-shadow: 0px 0px 18px 0px var(--black-7-opacity);
}

.Subcategories_subcategories__list-item--active__tPWua {
  background-color: var(--sky);
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .Subcategories_subcategories__iZqYK {
    width: 20rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Skus/Subcategories/Subcategories.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,6CAA6C;EAC7C,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;EACjD,qBAAqB;EACrB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".subcategories {\n  max-width: 26rem;\n  --padding-inline-start: 2rem;\n  border: 0.1rem solid var(--black-ten-opacity);\n  border-radius: 0.8rem;\n  padding-block: 1.7rem 1.2rem;\n  position: sticky;\n  top: 2rem;\n}\n\n.subcategories__header {\n  color: var(--primary-color);\n  font-size: var(--text-xl);\n  font-weight: 700;\n  padding-inline-start: var(--padding-inline-start);\n  margin-bottom: 1rem;\n}\n\n.subcategories__loading {\n  margin-inline: auto;\n  width: 8rem;\n  height: 6rem;\n}\n\n.subcategories__empty {\n  margin-block: 5rem;\n}\n\n.subcategories__empty :global(.icon-wrapper) {\n  padding: 2rem;\n}\n\n.subcategories__empty :global(.icon) {\n  width: 3rem;\n  height: 3rem;\n  object-fit: contain;\n}\n\n.subcategories__empty :global(.message) {\n  font-size: var(--text-sm);\n}\n\n.subcategories__list-item {\n  padding-inline-start: var(--padding-inline-start);\n  padding-block: 1.5rem;\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.subcategories__list-item:hover {\n  border-radius: 0.7rem;\n  box-shadow: 0px 0px 18px 0px var(--black-7-opacity);\n}\n\n.subcategories__list-item--active {\n  background-color: var(--sky);\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .subcategories {\n    width: 20rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subcategories": `Subcategories_subcategories__iZqYK`,
	"subcategories__header": `Subcategories_subcategories__header__xnljO`,
	"subcategories__loading": `Subcategories_subcategories__loading__oJP34`,
	"subcategories__empty": `Subcategories_subcategories__empty__HF7cf`,
	"subcategories__list-item": `Subcategories_subcategories__list-item__f5Jtg`,
	"subcategories__list-item--active": `Subcategories_subcategories__list-item--active__tPWua`
};
export default ___CSS_LOADER_EXPORT___;
